import React from "react";

const SIZE_MAP = {
  xs: "h-7 w-7 text-[10px]",
  sm: "h-8 w-8 text-xs",
  md: "h-11 w-11 text-sm",
  lg: "h-16 w-16 text-lg",
  xl: "h-24 w-24 text-2xl",
};

function getInitials(name) {
  return String(name || "?")
    .split(" ")
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export default function Avatar({
  src,
  name,
  alt,
  size = "md",
  className = "",
  locked = false,
  rounded = "soft",
}) {
  const sizeClass = SIZE_MAP[size] || SIZE_MAP.md;
  const roundedClass = rounded === "full" ? "rounded-full" : "rounded-2xl";

  return (
    <div
      className={`relative inline-flex flex-shrink-0 items-center justify-center overflow-hidden border border-slate-200 bg-slate-100 font-semibold text-slate-600 shadow-sm ${roundedClass} ${sizeClass} ${className}`}
    >
      {src ? (
        <img
          src={src}
          alt={alt || `Avatar de ${name || "joueur"}`}
          className={`h-full w-full object-cover ${locked ? "opacity-40" : ""}`}
        />
      ) : (
        <span>{getInitials(name)}</span>
      )}

      {locked && (
        <div className="absolute inset-0 flex items-center justify-center bg-slate-950/45 text-[10px] font-bold uppercase tracking-[0.16em] text-white">
          Lock
        </div>
      )}
    </div>
  );
}
